import { render, staticRenderFns } from "./EmployeeAgreementsDialog.vue?vue&type=template&id=2025a4ea&scoped=true&"
import script from "./EmployeeAgreementsDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeAgreementsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAgreementsDialog.vue?vue&type=style&index=0&id=2025a4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025a4ea",
  null
  
)

export default component.exports